export const baseRoute = '/sms';

export default {
  baseRoute,
};
